import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableSortAsc = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4 0L8 4H5V16H3V4H0L4 0ZM9 12H18V10H9V12ZM9 8H16V6H9V8ZM9 16H20V14H9V16ZM9 4H14V2H9V4Z",
		fill: "#616161"
	})]
});
const ForwardRef = forwardRef(SvgTableSortAsc);
export { ForwardRef as ReactComponent };
